// src/pages/AdminLogin.jsx
import React from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../store/auth';
import { useTranslation } from 'react-i18next';

const Wrap = styled.main` width:min(520px, 92vw); margin: 40px auto; padding: 18px; `;
const Card = styled.form`
  background: var(--card); border: 1px solid var(--bdr); border-radius: 18px; box-shadow: var(--shadow);
  padding: 18px; display: grid; gap: 12px;
`;
const Row = styled.div`display:grid; gap:6px;`;
const Label = styled.label`font-size:13px; color:var(--muted);`;
const Input = styled.input`
  padding: 12px 14px; border-radius: 14px; border:1px solid var(--bdr); background: var(--card); color: inherit;
`;
const Actions = styled.div`display:flex; gap:10px; justify-content:flex-end;`;
const Btn = styled.button`
  padding:10px 14px; border-radius:14px; font-weight:700;
  border:1px solid var(--bdr); background: var(--primary); color: var(--primaryFg);
`;

export default function AdminLogin() {
  const { t } = useTranslation();
  const [login, setLogin] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [err, setErr] = React.useState('');
  const authLogin = useAuth(s => s.login);
  const navigate = useNavigate();
  const location = useLocation();

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    
    const r = await authLogin(login.trim(), password);
    
    if (r.ok) {
      const to = location.state?.from?.pathname || '/admin';
      navigate(to, { replace: true });
    } else {
      setErr(t('admin.login.error'));
    }
  };

  return (
    <Wrap className="container">
      <h1>{t('admin.login.title')}</h1>
      <Card onSubmit={onSubmit}>
        <Row>
          <Label>{t('admin.login.username')}</Label>
          <Input value={login} onChange={e=>setLogin(e.target.value)} placeholder="admin" />
        </Row>
        <Row>
          <Label>{t('admin.login.password')}</Label>
          <Input type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="••••••••" />
        </Row>
        {err && <div style={{color:'#e66'}}>{err}</div>}
        <Actions>
          <Btn type="submit">{t('admin.login.signIn')}</Btn>
        </Actions>
        <div style={{opacity:.6, fontSize:13}}>
          {t('admin.login.devHint', { u:'admin', p:'admin123' })}
        </div>
      </Card>
    </Wrap>
  );
}
